export default __webpack_public_path__ + "140a6b66934389d65fae809e69c2cff7.svg";